import { Dimensions, StatusBar, Platform } from 'react-native';
import { DeviceInfo } from 'qunar-react-native';

const IsIphoneX = DeviceInfo.isIphoneX;
const iOSStatusBarHeight = IsIphoneX ?44.0: 20.0;
const StatusBarComponentHeight = 50;
const navBarHeight = 58;

const Iphone6DeviceWidth = 375;

export const ScreenWidth =
    Dimensions.get('window').height > Dimensions.get('window').width
        ? Dimensions.get('window').width
        : Dimensions.get('window').height;
export const ScreenHeight =
    Dimensions.get('window').height > Dimensions.get('window').width
        ? Dimensions.get('window').height
        : Dimensions.get('window').width;


let currentScreenWidth = ScreenWidth;
let currentScreenHeight = ScreenHeight;

export default class SizeUtil {
    public static getSize = (size: number) => {
        return (size * currentScreenWidth) / Iphone6DeviceWidth;
    };

    public static updateScreenSize = (screenSize: any)=>{
        if (!screenSize || !screenSize.width || !screenSize.height) return;
        currentScreenWidth = screenSize.width;
        currentScreenHeight = screenSize.height;
      }
    
    // 通过一个百分比获取距离屏幕顶部的高度
    public static getHeightByPercent= (percent: number = 0.22) => {
        const statusbarHeight = (Platform.OS === 'android' ? StatusBar.currentHeight : iOSStatusBarHeight);
        return ScreenHeight * percent - navBarHeight - StatusBarComponentHeight - statusbarHeight;
    }

    // 用来计算订单组件的Y值（订单本身是一个组件，接入行程之后，其实并不是全屏的）
    // 注意：这里假定高度是固定的，如果顶部距离变了，需要适配
    public static getRootViewY = () => {
        const statusbarHeight = (Platform.OS === 'android' ? StatusBar.currentHeight : iOSStatusBarHeight);
        return navBarHeight + StatusBarComponentHeight + statusbarHeight;
    }
}
